<div class="container-fluid">
  <div class="header-container">
    <div class="header-container">
      <div class="page-header">Gear Advice Management</div>
      <div class="loading" *ngIf="loading">
        <div class="loader"></div>
      </div>
    </div>
    <div class="advice-header" *ngIf="!loading">
      <div class="right">
        <a [routerLink]="[ '/administration/bike-gear-advice/create' ]"><button pButton class="full-width accent"
            label="Create Advice"></button></a>
      </div>
    </div>
  </div>
  <div style="margin-top:70px;">
    <div *ngFor="let bikeType of bikeTypes()">
      <h6 style="margin-top: 16px;text-transform: uppercase;">{{bikeType}}</h6>
      <div class="menu-container">
        <div *ngFor="let advice of getAdvices(bikeType)" class="menu-card-container">
          <a
            [routerLink]="[ '/administration/bike-gear-advice/'+advice.id ]">
            <div class="menu-card">
              <div class="menu-header"
                [ngStyle]="{'background-image': 'url('+(advice.headerImageURL.length>0 ? advice.headerImageURL : '')+')','filter': !advice.adviceActive && !advice.recommendationActive  ? 'saturate(0)' : ''}">

              </div>
              <div class="menu-footer" [ngClass]="{'overlay': advice.headerImageURL.length>0}">
                <div>{{advice.bikeType}}</div>
                <div>{{advice.gearType}} - {{advice.languageCode}}</div>                
                <div class="status">
                  <div>Recommendation<span class="fa fa-minus-circle white" [ngClass]="{'green hubtiger-check': advice.recommendationActive}"></span></div>
                  <div>Advice<span class="fa fa-minus-circle white" [ngClass]="{'green hubtiger-check': advice.adviceActive}"></span></div>
                </div>
                <div *ngIf="advice.otherBikes > 0" style="position: absolute;bottom:16px">{{advice.otherBikes}} other linked bikes</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="advices && advices.length===0 && !loading">
      You have no recommendations or advices configured.
    </div>
  </div>
</div>